// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-0fcb6d7e]{display:none}.copyright[data-v-0fcb6d7e]{width:100%;padding:40px 0;background:var(--c-secondary);color:var(--c-light-variant);text-align:center;box-sizing:border-box}@media(max-width:1023px){.copyright[data-v-0fcb6d7e]{padding:30px 16px;text-align:left}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
